/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="7">
        <div class="leftaside">
          <h4>商家入驻指南</h4>
          <div class="left_product">
            <el-menu
              default-active="4"
              class="el-menu-vertical-demo"
              :unique-opened='true'
              background-color="#f7f8f8"
            >
              <el-submenu index="1">
                <template slot="title">入驻流程</template>
                <el-menu-item index="0-1">商家提交申请</el-menu-item>
                <el-menu-item index="0-2">平台审核资质</el-menu-item>
                <el-menu-item index="0-3">商家缴纳费用</el-menu-item>
                <el-menu-item index="0-4">店铺开通</el-menu-item>
              </el-submenu>
              <el-menu-item index="2">
                <template slot="title"
                  >签订入驻协议</template
                >
              </el-menu-item>
              <el-menu-item index="3">
                <template slot="title"
                  >选择店铺类型</template
                >
              </el-menu-item>
              <el-menu-item index="4">
                <template slot="title"
                  >平台审核</template
                >
              </el-menu-item>
              <el-menu-item index="5">
                <template slot="title"
                  >合同签订及缴费</template
                >
              </el-menu-item>
              <el-menu-item index="6">
                <template slot="title"
                  >店铺开通</template
                >
              </el-menu-item>
            </el-menu>
          </div>
        </div>
       <div class="leftaside">
          <h4>平台联系方式</h4>
          <div class="left_product" style="padding: 20px">
            <p>电话：400-0404-119</p>
            <p>邮箱：nays@nays.com.cn</p>
          </div>
        </div>
      </el-col>
      <el-col :span="17" class="rightaside">
        <div>
          <h3 v-show="isSuccess==1?true:false" class="blueStatus"> 入驻申请已经提交，请等待管理员审核</h3>
          <h3 v-show="isSuccess==2?true:false" class="greenStatus"> 审核已通过, 去<router-link class="payfor" to="/merchantpayFor">缴费</router-link></h3>
          <h3 v-show="isSuccess==3?true:false" class="blueStatus"> 审核没通过，点击 <a href="javascript:;" style="text-decoration: underline;color: #f42424;font-size: 14px;" @click="reApply">重新申请</a></h3>
          <el-divider></el-divider>
          <el-row class="outBoxLine">
            <el-col class="titleBorderline" :span="24"><div class="grid-content bg-purple">付款清单列表</div></el-col>
            <el-col class="borderline" :span="4"><div class="grid-content bg-purple">收费标准:</div></el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light">{{payForList.margin || 0.00}}</div></el-col>
            <el-col class="borderline" :span="4"><div class="grid-content bg-purple">开店时长:</div></el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light">{{payForList.time || 0}}</div></el-col>

            <el-col class="borderline" :span="4"><div class="grid-content bg-purple"></div>经营类:</el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light jy_bg_css" :title="payForList.types || '--'">{{payForList.types || '--'}}</div></el-col>            
            <el-col class="borderline" :span="4"><div class="grid-content bg-purple-light">开店保证金:</div></el-col>
            <el-col class="borderline" :span="8"><div class="grid-content bg-purple-light">{{Marginmonry ||0.00}}</div></el-col>
        </el-row>        
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {getMercharntStatus,merchants_pay_list,reApplyApi,checkMargin} from '@/api/xunyou'
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isSuccess:1, // 店铺开通状态
        payForList:{}, //付费清单
        Marginmonry:0 //保证金
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    this.goToSettleIn();
    this.getPayFor()
    this.getMargin()
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取保证金额
    getMargin(){
      const bxscId = localStorage.getItem('bxscId')
      checkMargin({bxscId}).then(res=>{
        // console.log(res)
        if(res.code==0){
          this.Marginmonry = res.data
        }
      })
    },
     // 判断审核状态
    // statusType(status){
    //    switch(status) {
    //         case 1:
    //             return  this.$router.push('/merchantApply?type=3')
    //             break;
    //         case 2:
    //              return this.$router.push('/merchantStatus')
    //             break;
    //         case 3:
    //              return this.$router.push('/menchantpayFor')
    //             break;
    //         case 4:
    //              return this.$router.push('/storeOpen')
    //         default:                
    //             return '--'
    //     } 
    // },
    // 状态查询
    goToSettleIn(){
      getMercharntStatus({username:this.userInfo.loginName})
            .then(res => {
              if (res.code == 0) {
                // this.statusType(res.data)
                this.isSuccess = res.data
              } else {
                this.$message({
                  type: 'info',
                  message: '查询失败，请稍后再试！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })     
    },

    // 重新申请商家入驻
    reApply(){
       reApplyApi({username:this.userInfo.loginName})
            .then(res => {
              if (res.code == 0) {
                this.goToSettleIn()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('申请失败，请稍后再试！')
            })  
    },

    // 查询付费清单
    getPayFor(){
      merchants_pay_list({name:this.userInfo.loginName})
            .then(res => {
              if (res.code == 0) {
                // this.statusType(res.data)
                this.payForList = res.data
              } else {
                this.$message({
                  type: 'info',
                  message: '查询失败，请稍后再试！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })     
    }
  },
};
</script>

<style scoped lang="less">
.jy_bg_css{
    height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside {
  width: 300px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 40px;
  .el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
  }
  /deep/.el-submenu__title,.el-menu-item {
    height: 40px;
    line-height: 40px;
  }
  /deep/.el-submenu__title:focus,
  /deep/.el-submenu__title:hover,
  /deep/.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow,
  /deep/.el-menu-item.is-active {
    color: #f42424;
  }  
}
.leftaside h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  font-weight: 700;
}

.rightaside{
    h3 {
    font-size: 14px;
    color: #333;
    padding: 14px;
    border-radius: 4px;
  }
  .payfor{
      color:#004cc4;
      text-decoration: underline;
  }
  .greenStatus{
      background: #e1f7d9;
      border: 1px solid #c4f9bc;
  }
  .blueStatus{
      background: #d9edf7;
      border: 1px solid #bce5f9;
  }
  .outBoxLine.el-row {
      border: 1px solid #ccc;
      border-bottom: none;

  }
  .titleBorderline{
    border-bottom: 1px solid #ccc;
    font-size: 18px;
    background: #e6e6e6;
    padding:14px;
    color:#333
 }
 .borderline {
    padding: 8px 14px;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}
    .statusStep{

    }
    // .nextPart{
    //   margin-top:20px;
    // }
    // .nextButtom{
    //     background: #ff6700;
    //     border: 1px solid #ff6700;
    // }
}

</style>

 
 

 


// WEBPACK FOOTER //
// src/views/merchantSettled/merchantStatus.vue